module.exports = __webpack_public_path__ + "img/cdplayer.962dd5de.png";